import React from "react";

import Footer from "./footer";

import { Link } from 'react-router-dom';
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";


function Services() {
   return (

      // aboutcompany
      <>


         <div className="space80"></div>




         <div className="about-company">
            <div className="space80"></div>
            <div className="hero-area10 ">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="title title2  ">

                           <h1 className="sk-text-color text-center">Services </h1>

                        </div>
                     </div>

                  </div>
                  <div className="space50"></div>
                  <div className="row justify-content-center">

                  <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/itrfiling">
                           <div className="single-service text-center">
                              <div className="service-icon bg-23">
                                 <img src="assets/img/icons/E-Filing-Income-Tax.png" alt="" />
                              </div>
                              <h3>ITR Filing</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/gstreturnfiling">
                           <div className="single-service text-center">
                              <div className="service-icon bg-17">
                                 <img src="assets/img/icons/Online-GST-Return-Filing.png" alt="" />
                              </div>
                              <h3>GST Return Filing Online</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/tdsreturnfiling">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/service-5.png" alt="" />
                              </div>
                              <h3>TDS Return Filing</h3>
                           </div>
                        </Link>
                     </div>
                     
                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/onlineaccounting">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/Online-Accounting.png" alt="" />
                              </div>
                              <h3>Online Accounting</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/gstregistration">
                           <div className="single-service text-center">
                              <div className="service-icon bg-21">
                                 <img src="assets/img/icons/Online-GST-Registration.png" alt="" />
                              </div>
                              <h3>GST Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/trademarkregistration">
                           <div className="single-service text-center">
                              <div className="service-icon bg-18">
                                 <img src="assets/img/icons/Trademark-Registration-Service.png" alt="" />
                              </div>
                              <h3>Trademark Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/foodlicence">
                           <div className="single-service text-center">
                              <div className="service-icon bg-22">
                                 <img src="assets/img/icons/service-7.png" alt="" />
                              </div>
                              <h3>FSSAI Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/gumastalicense">
                           <div className="single-service text-center">
                              <div className="service-icon bg-15">
                                 <img src="assets/img/icons/Gumasta-License.png" alt="" />
                              </div>
                              <h3>Shop Act License (Gumasta)</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/importexportlicenseiec">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/IEC-Registration-Online---Apply-for-Import-Export-License.png" alt="" />
                              </div>
                              <h3>Import Export License (IEC)
                              </h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/msmeregistration">
                           <div className="single-service text-center">
                              <div className="service-icon bg-19 msme">
                                 <img src="assets/img/icons/MSME-Registration-Online.png" alt="" />
                              </div>
                              <h3>MSME Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/legalclaimhelp">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/Legal-Advice.png" alt="" />
                              </div>
                              <h3>Legal Advice</h3>
                           </div>
                        </Link>
                     </div>

                     
                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/legalnotice">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/Legal-Notice-Preparation.png" alt="" />
                              </div>
                              <h3>Legal Notice</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/legalnoticereply">
                           <div className="single-service text-center">
                              <div className="service-icon bg-16">
                                 <img src="assets/img/icons/Legal-Notice-Reply.png" alt="" />
                              </div>
                              <h3>Legal Notice Reply</h3>
                           </div>
                        </Link>
                     </div>

                  
                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/pvtltdcompanyregistration">

                           <div className="single-service text-center">
                              <div className="service-icon bg-15">
                                 <img src="assets/img/icons/Pvt.-Ltd.-Company-Registration.png" alt="" />
                              </div>
                              <h3>Pvt. Ltd. Company Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/section8companyregistration">

                           <div className="single-service text-center">
                              <div className="service-icon bg-18">
                                 <img src="assets/img/icons/Section-8-Company-Registration.png" alt="" />
                              </div>
                              <h3>Section 8 Company Registration</h3>
                           </div>
                        </Link>
                     </div>


                  

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/opccompanyregistration">
                           <div className="single-service text-center">
                              <div className="service-icon bg-22">
                                 <img src="assets/img/icons/One-Person-Company-(OPC)-Registration.png" alt="" />
                              </div>
                              <h3>One Person Company Registration</h3>
                           </div>
                        </Link>
                     </div>
                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/parternshipeed" >

                           <div className="single-service text-center">
                              <div className="service-icon bg-19">
                                 <img src="assets/img/icons/service-1.png" alt="" />
                              </div>
                              <h3>Partnership Registration</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/llpcompanyregistration">
                           <div className="single-service text-center">
                              <div className="service-icon bg-21">
                                 <img src="assets/img/icons/Limited-Liability-Partnership-(LLP)-Registration.png" alt="" />
                              </div>
                              <h3>LLP Registration</h3>
                           </div>
                        </Link>
                     </div>


                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/annualcompliancellp">
                           <div className="single-service text-center">
                              <div className="service-icon bg-17">
                                 <img src="assets/img/icons/service-6.png" alt="" />
                              </div>
                              <h3>Annual Compliance Company (LLP)</h3>
                           </div>
                        </Link>
                     </div>

                     <div className="col-md-4 col-lg-3 col-6">
                        <Link to="/annualcompliancepvtltd">
                           <div className="single-service text-center">
                              <div className="service-icon bg-23">
                                 <img src="assets/img/icons/service-7.png" alt="" />
                              </div>
                              <h3>Annual Compliance of Company</h3>
                           </div>
                        </Link>
                     </div>
               

                

                  
                 
                 
               
                  
                  
                   

                    

                 

                  

                  </div>
               </div>
            </div>





            <div className="space50"></div>





         </div>






         <WhatsAppScrollButton />

         <Footer />

         <CircularScrollProgress />


      </>
   );
}

export default Services;